/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ForecastSurplusModal_viewer = {
    readonly project: {
        readonly id: string;
        readonly name: string | null;
        readonly companyProjectId: number | null;
        readonly revenueMarginLow: number | null;
        readonly revenueMarginHigh: number | null;
        readonly rateCard: {
            readonly currency: string | null;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"ForecastSurplusModalChartSection_project">;
    } | null;
    readonly " $refType": "ForecastSurplusModal_viewer";
};
export type ForecastSurplusModal_viewer$data = ForecastSurplusModal_viewer;
export type ForecastSurplusModal_viewer$key = {
    readonly " $data"?: ForecastSurplusModal_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ForecastSurplusModal_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId",
      "type": "ID"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ForecastSurplusModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "internalId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyProjectId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "revenueMarginLow",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "revenueMarginHigh",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RateCard",
          "kind": "LinkedField",
          "name": "rateCard",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ForecastSurplusModalChartSection_project"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = 'abd7c165ebd72a968530d7e7a34dc4ad';
export default node;
